import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

//import { UserDependentRequest } from '../types';
// import { PaginationType } from 'src/app/shared/models/pagination.model';
// import { Pagination } from '../utils/constants';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class User1Service {
  constructor(private apiService: ApiService) { }

  register(model: any): Observable<any> {
    return this.apiService.post('/user/register', model);
  }
  confirmEmail(model: any): Observable<any> {
    return this.apiService.post('/user/confirm/email', model);
  }
  changePassword(model: any): Observable<any> {
    return this.apiService.post('/user/change/password', model);
  }
  updateProfile(model: any): Observable<any> {
    return this.apiService.post('/user/update/profile', model);
  }
  userProfile() {
    return this.apiService.get('/user/profile');
  }
  userKyc() {
    return this.apiService.get('/user/kyc');
  }
  kycByUser(userId: string) {
    return this.apiService.get(`/user/kyc/${userId}`);
  }
  upgradeKyc(model: any): Observable<any> {
    return this.apiService.post('/user/kyc/upgrade', model);
  }
  getCurrentKyc() {
    return this.apiService.get('/user/kyc/tier/current');
  }

  getKycDetail(tierID: any) {
    return this.apiService.get('/user/kyc/detail/' + tierID);
  }
  userInfo() {
    return this.apiService.get('/user/userInfo');
  }
  getUserInfo(userId: string) {
    return this.apiService.get('/user/userInfo/' + userId);
  }

    getUserInfoWithoutLoading(userId: string) {
    return this.apiService.get('/user/userInfo/' + userId + "#isNoLoading=true");
  }

  getVerifiedUserByNameOrIc(nameOrIc: string) {
    return this.apiService.get('/user/userInfo/verified/by-koperasi/' + nameOrIc);
  }

  forgotPassword(model: any): Observable<any> {
    return this.apiService.post('/user/password/forgot', model);
  }
  resetPassword(model: any): Observable<any> {
    return this.apiService.post('/user/reset/password', model);
  }

  getMyKyc() {
    return this.apiService.get('/user/mykyc');
  }

  checkUser(ic: string, email: string) {
    return this.apiService.get('/user/check?ic=' + ic + '&email=' + email);
  }

  checkIntroducer(code: string) {
    return this.apiService.get('/user/refcode/check/' + code);
  }

  registerAsk(model: any) {
    return this.apiService.post('/user/register/ask/account', model);
  }

  checkAskAccount() {
    return this.apiService.get('/user/check/ask');
  }

  checkUserAskAccount(userId: string) {
    return this.apiService.get(`/user/check/ask/${userId}`);
  }

  registerFcm(model: any) {
    return this.apiService.post('/user/register/fcm', model);
  }
  getTenantName(tenantId: string) {
    return this.apiService.get('/user/getTenantName/' + tenantId);
  }

  getTenantInfo(tenantId: string) {
    return this.apiService.get('/user/getTenantInfo/' + tenantId);
  }

  getAskBalance() {
    return this.apiService.get('/user/ask/balance');
  }

  getReferral() {
    return this.apiService.get('/user/referral');
  }
  getPromotions() {
    return this.apiService.get('/user/promotions');
  }
  getPaymentResult(billcode: string) {
    return this.apiService.get('/payment/check/' + billcode);
  }
  getPaymentHistory(billcode: string) {
    return this.apiService.get('/payment/get/' + billcode);
  }
  updatePaymentStatus(billCode: string, statusId: number) {
    return this.apiService.post(`/payment/updateStatus/${billCode}/${statusId}`)
  }
  getNotifications() {
    return this.apiService.get('/user/notifications');
  }
  markReadNotification(id: string) {
    return this.apiService.post('/user/notification/read/' + id + `#isNoLoading=true`);
  }
  
  logout() {
    return this.apiService.post('/user/logout');
  }
  getServiceNotice() {
    return this.apiService.get('/user/service/notice');
  }
  getUserBanks() {
    return this.apiService.get('/user/bank/list');
  }
  getUserDefaultBank(userId: string) {
    return this.apiService.get(`/user/bank-account/main/${userId}`);
  }
  addUserBank(model: any) {
    return this.apiService.post('/user/bank/add', model);
  }
  getAskSeryBalance() {
    return this.apiService.get('/user/ask/sery/balance');
  }
  checkExistAsk() {
    return this.apiService.get('/user/exist/ask');
  }
  getHqUser(tenantId: string) {
    return this.apiService.get('/user/userInfoByTenant/' + tenantId);
  }

  deleteUserbank(id: any) {
    return this.apiService.delete(`/user/banks/${id}`);
  }

  loginWithKop(tenantId: string, isRememberMe: boolean) {
    return this.apiService.post(`/user/koperasi/select/${tenantId}?isRememberMe=${isRememberMe ?? false}`);
  }

  applyToKop(id: string) {
    return this.apiService.post(`/user/koperasi/apply/${id}`);
  }

  // addDependent(request: UserDependentRequest) {
  //   return this.apiService.post(`/user/dependents`, request);
  // }

  // updateDependent(request: UserDependentRequest) {
  //   return this.apiService.put(`/user/dependents/${request.id}`, request);
  // }

  deleteDependent(id: string) {
    return this.apiService.delete(`/user/dependents/${id}`);
  }

  // getDependents(keyword: any, pagination: PaginationType) {
  //   return this.apiService.get(`/user/dependents` + Pagination.getPaginationQuery(keyword, pagination));
  // }

  getDependent(id: string) {
    return this.apiService.get(`/user/dependents/${id}`);
  }

  // getUserByWalletId(walletId: string) {
  //   return this.apiService.get(`/user/by-wallet/${walletId}`);
  // }

  getUserByWalletOrName(walletOrName: string) {
    return this.apiService.get(`/user/wallet/search/${walletOrName}`);
  }

  getMainAddressDetails() {
    return this.apiService.get(`/user/main-shipping-address`);
  }

  saveMainAddressDetails(model: any) {
    return this.apiService.post(`/user/save-main-shipping-address`, model);
  }

  deactivateAccount() {
    return this.apiService.post(`/user/deactive`);
  }

  checkExistUser(userName: string, email: string) {
    return this.apiService.get(`/admin/users/check-user-name?userName=${userName}&email=${email}`)
  }

  resendCode(userName: string, securityStamp: any) {
    return this.apiService.post(`/user/resend-code`, { userName, securityStamp })
  }

  getNotificationsV2(pageIndex: any, pageSize: any) {
    return this.apiService.get(`/user/notifications-new?pageIndex=${pageIndex}&pageSize=${pageSize}&isNoLoading=true`)
  }

  getUnread() {
    return this.apiService.get(`/user/notifications-new/get-unread`);
  }

  getAllTenants() {
    return this.apiService.get(`/user/tenants`);
  }
}
